/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stats_CanadianInputs */

const en_home_stats_canadian = /** @type {(inputs: Home_Stats_CanadianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Canadian`)
};

const fr_home_stats_canadian = /** @type {(inputs: Home_Stats_CanadianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% canadien`)
};

/**
* | output |
* | --- |
* | "100% Canadian" |
*
* @param {Home_Stats_CanadianInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_stats_canadian = /** @type {((inputs?: Home_Stats_CanadianInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stats_CanadianInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_stats_canadian(inputs)
	return fr_home_stats_canadian(inputs)
});